/* Publish by EComposer at 2024-07-17 09:41:42*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cubk8ppzd3f"]=  window.__ectimmers["ecom-cubk8ppzd3f"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-cubk8ppzd3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cubk8ppzd3f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-68ehj41ohsh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-68ehj41ohsh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dzhwmm49ub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dzhwmm49ub', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k0cbfkhiwf8"]=  window.__ectimmers["ecom-k0cbfkhiwf8"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-k0cbfkhiwf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0cbfkhiwf8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6q7qcjn9wn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6q7qcjn9wn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0g7q3l2k4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0g7q3l2k4i', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}